/* eslint-disable */
import Header from "components/Common/Header/Header";
import SettingsBody from "components/MarketplaceComponents/SettingsComponents/SettingsBody/SettingsBody";
import { useEffect } from "react";

const OrderList = () => {
  useEffect(() => {
    document.title = "Settings";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="marketplace" />

      <SettingsBody />
    </main>
  );
};

export default OrderList;
